const API_ROUTE = 'https://nutrition-api.adriandumitrache.com/api';
// const API_ROUTE = 'http://localhost:5200/api';
const ApiClient = {
    get: (url, params = {}, headers) => {
        return ApiClient.makeRequest(
            `${API_ROUTE}/${url}`,
            "GET",
            {},
            headers
        );
    },

    post: (url, params = {}, headers, isMultipart = false) => {
        return ApiClient.makeRequest(
            `${API_ROUTE}/${url}`,
            "POST",
            params,
            headers,
            isMultipart
        );
    },

    put: (url, params = {}, headers) => {
        return ApiClient.makeRequest(
            `${API_ROUTE}/${url}`,
            "PUT",
            params,
            headers
        );
    },

    patch: (url, params = {}, headers) => {
        return ApiClient.makeRequest(
            `${API_ROUTE}/${url}`,
            "PATCH",
            params,
            headers
        );
    },

    delete: (url, params = {}, headers) => {
        return ApiClient.makeRequest(
            `${API_ROUTE}/${url}`,
            "DELETE",
            params,
            headers
        );
    },

    makeRequest: async (
        url,
        type,
        params = {},
        headers = {},
        isMultipart = false
    ) => {
        try {
            type = type.toUpperCase();
            const accessToken = localStorage.getItem('accessToken') || '';
            headers = {
                'accept': 'text/plain',
                'Content-Type': isMultipart ? 'multipart/form-data' : 'application/json',
                'Authorization': `Bearer ${accessToken}`,
                ...headers,
            };
            const request = {
                method: type,
                headers: headers,
            };
            if (type === "POST" || type === "PUT" || type === "PATCH") {
                request.body = isMultipart ? params : JSON.stringify(params);
            }

            const result = await fetch(url, request);

            if (result.status === 401) {
                const userID = localStorage.getItem('userID');
                const refreshToken = localStorage.getItem('refreshToken');
                if (userID && refreshToken) {
                    const refreshResult = await ApiClient.post('refreshToken', { userID, refreshToken });
                    if (refreshResult && refreshResult.accessToken) {
                        localStorage.setItem('accessToken', refreshResult.accessToken);
                        localStorage.setItem('refreshToken', refreshResult.refreshToken);

                        headers.Authorization = `Bearer ${refreshResult.accessToken}`;
                        result = await fetch(url, { ...request, headers });
                    } else {
                        window.location.href = "/logout";
                        return;
                    }
                } else {
                    window.location.href = "/logout";
                    return;
                }
            }

            if (isMultipart) return await result.text();
            return await result.json();
        } catch (error) {
            throw error.message;
        }
    },

    getImage: async (url, headers = {}) => {
        const accessToken = localStorage.getItem('accessToken') || '';
        headers = {
            'Authorization': `Bearer ${accessToken}`,
            ...headers,
        };
        const result = await fetch(`${API_ROUTE}/${url}`, {
            method: 'GET',
            headers,
        });
        if (!result.ok) return null;
        return await result.blob();
    },
    uploadImage: async (url, file) => {
        const accessToken = localStorage.getItem('accessToken') || '';

        const formData = new FormData();
        formData.append('image', file);

        const fetchUpload = async (token) => {
            return await fetch(`${API_ROUTE}/${url}`, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${token}`,
                },
                body: formData
            });
        };

        let result = await fetchUpload(accessToken);

        if (result.status === 401) {
            const userID = localStorage.getItem('userID');
            const refreshToken = localStorage.getItem('refreshToken');

            if (userID && refreshToken) {
                const refreshResult = await ApiClient.post('refreshToken', { userID, refreshToken });
                if (refreshResult && refreshResult.accessToken) {
                    localStorage.setItem('accessToken', refreshResult.accessToken);
                    localStorage.setItem('refreshToken', refreshResult.refreshToken);

                    result = await fetchUpload(refreshResult.accessToken);
                } else {
                    window.location.href = "/logout";
                    return null;
                }
            } else {
                window.location.href = "/logout";
                return null;
            }
        }

        return await result.json();
    }
};
export { API_ROUTE, ApiClient };

